import { useState } from "react";
import api from "../../services/api";
import "./update.scss";
import { useMutation, useQueryClient } from "react-query";

const Update = ({ setOpenUpdate, user }) => {
  const [texts, setTexts] = useState({
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name,
  });


  const handleChange = (e) => {
    setTexts((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const queryClient = useQueryClient();

  const mutation = useMutation(
    (user) => {
      return api.put("/api/user/", user);
    },
    {
      onSuccess: () => {
        // Invalidate and refetch
        queryClient.invalidateQueries(["user"]);
      },
    }
  );

  const handleClick = async (e) => {
    e.preventDefault();

    mutation.mutate({ ...texts, id: user.id });
    setOpenUpdate(false);
  };

  return (
    <div className="update">
      <div className="wrapper">
        <h1>Update Your Profile</h1>
        <form>
          <label>First Name</label>
          <input
            type="text"
            value={texts.first_name}
            name="first_name"
            onChange={handleChange}
          />
          <label>Last Name</label>
          <input
            type="text"
            value={texts.last_name}
            name="last_name"
            onChange={handleChange}
          />
          <label>Email</label>
          <input
            type="text"
            value={texts.email}
            name="email"
            onChange={handleChange}
          />
          <button onClick={handleClick}>Update</button>
        </form>
        <button className="close" onClick={() => setOpenUpdate(false)}>
          close
        </button>
      </div>
    </div>
  );
};

export default Update;
